function clamp(value, max, min) {
  return value > max ? max : value < min ? min : value;
}
export {
  clamp
};
//# sourceMappingURL=utils.js.map
